import React, { useEffect, useMemo, useState } from 'react'
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import {
    createClickableLink,
    SearchSelectWithIndeterminateBoolean
} from "../../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import { SearchSelectWithEnum, SearchSelectWithList } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { getBooleanDisplayIcon, getCurrentTaxYear, getStateValueFromParam } from "../../../../helpers/utils/Utils";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import Breadcrumb from '../../../../components/common/Breadcrumbs';
import { DataTable } from '../../../../components/common/datatable/DataTable';
import { useLazyExportJurisdictionDataQuery, useSearchAllJurisdictionQuery } from '../jurisdictionApi';
import { useGetAllStatesQuery } from '../../states/statesApi';
import { useLazyGetAllCountyByStateAbbrQuery } from '../../counties/countiesApi';
import { FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import IconButton from '../../../../components/common/form/IconButton';
import CollectorSearchInputWrapper from '../../../../components/common/datatable/filter/CollectorSearchInputWrapper';


const Jurisdictions = () => {
    const { data: enums } = useGetEnumsQuery("");
    const navigate = useNavigate()
    const state = getStateValueFromParam(window,"stateAbbreviation");
    const [getAllCountyByStateAbbrApi, getAllCountyByStateAbbrApiResponse] = useLazyGetAllCountyByStateAbbrQuery()


    useEffect(() => {
        getAllCountyByStateAbbrApi(state);
    }, [state]);


    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Jurisdictions", url: "" }]
    )
    useEffect(() => {
        document.title = 'Jurisdictions';

    }, []);
    const taxYear = useMemo(() => getCurrentTaxYear(),
        []);

    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("Jurisdictions");
    const stateQueryApi = useGetAllStatesQuery("");
    const [exportJurisdictionAction] = useLazyExportJurisdictionDataQuery();

    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "name",
            cell: (props: any) => {
                let path = `/jurisdictions/${props.row.original.id}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["JURI-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."} name={"name"}
                    accessor={"name"} />,
            }]
        },
        {
            label: "Type",
            accessor: "jurisdictionType",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["JurisdictionType"], props.value)}</span></>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["JurisdictionType"], "Select Type...", false, "jurisdictionType"),
            }]
        },
        {
            label: "State", accessor: "collector.state.stateAbbreviation",
            filterOptions: [{
                dependentColumns: ["County"],
                filterComponent: SearchSelectWithList(stateQueryApi?.data, "stateName", "stateAbbreviation", "Select State...", false, "stateAbbreviation"),
                overrideFilterAccessor: "stateAbbreviation"
            }],
        },
        {
            label: "County",
            accessor: "countyName",
            filterOptions: [{
                filterComponent: SearchSelectWithList(
                    getAllCountyByStateAbbrApiResponse?.data,
                    "countyName",
                    "id",
                    "Select County...",
                    false,
                    "countyId"
                ),
                overrideFilterAccessor: "countyId",
                onDependencyUpdated: (value: string) => {
                    getAllCountyByStateAbbrApi(value);
                },
            }]
        },

        {
            label: "Collector",
            accessor: "collector.name",
            visibility: { hasShowSetting: false },
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper accessor="collectorName" />,
                overrideFilterAccessor: "collectorName",
                overrideFilterLabel: "Collector",
            }]
        },

        {
            label: "Tax Rate (" + taxYear + ")", accessor: "taxRates.rate",
            cell: (props: any) => {
                let rate = null;
                props.row.original.taxRates.map((taxRateForYear: any) => {
                    if (taxRateForYear.year === taxYear) {
                        rate = taxRateForYear.rate;
                    }
                });
                return rate;
            },
        },
        {
            label: "Codes(s)", accessor: "jurisdictionCodes.code",
            cell: (props: any) => {
                return <>
                    {
                        props.row.original.jurisdictionCodes && props.row.original.jurisdictionCodes.map((jurisdiction: any, index: any) => {
                            return (
                                <>
                                    <span className="text_wrap_msa_grid"
                                        title={jurisdiction.type}>{jurisdiction.code}{index + 1 >= props.row.original.jurisdictionCodes.length ? '' : ', '}</span>
                                </>
                            )
                        })}
                </>
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Code..."} name={"code"}
                    accessor={"name"} />,
                overrideFilterLabel: "Code",
                overrideFilterAccessor: "code"
            }]
        },

        {
            label: "Attorney Fee Percentage", accessor: "attorneyFeePercentage",
            cell: (props: any) => {
                return props.row.original.attorneyFeePercentage !== null ? props.row.original.attorneyFeePercentage * 100 + "%" : "0.2%";
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"number"}
                    placeholder={"Enter Attorney Fee Percentage..."}
                    accessor={"attorneyFeePercentage"} />,
                overrideFilterLabel: "Attorney Fee Percentage",
                overrideFilterAccessor: "attorneyFeePercentage"
            }]
        },


        {
            label: "Status", accessor: "inActive",
            cell: (props: any) => getBooleanDisplayIcon(!props.row.original.inActive, "Active", "Inactive"),
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Select Status...", "inActive", "InActive", "Active"),
                overrideFilterLabel: "Status"
            }]
        },
    ]
    return (
        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchAllJurisdictionQuery,
                    exportAction:exportJurisdictionAction
                }}
                userSettingGroup={"Jurisdictions"}
                defaultSortOptions={{
                    accessor: "creationDate",
                    direction: "asc"
                }}
                defaultFilter={{
                    stateAbbreviation: "TX"
                }}
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/jurisdictions/create")
                            }}
                            title={"Create Jurisdiction Link"}
                        />,
                        permissions: ["JURI-C"]
                    },
                }}
                basePermission={"JURI"}
            />

        </div>
    );
}

export default Jurisdictions;